import { Badge, BadgeColor } from '@givebutter/primitives/badge';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCurrentTransactionOrById } from 'customHooks/useCurrentTransactionOrById';
import { TransactionIntegrationStatus } from 'types/domain';

const TransactionIntegrationStatusBadge = () => {
    const { data: transaction } = useCurrentTransactionOrById();
    const { color, icon, text } = getIntegrationStatusProps(transaction?.integration_status);

    if (text.length === 0) {
        return null;
    }

    return (
        <Badge color={color}>
            {icon && <FontAwesomeIcon size={'sm'} icon={icon} />}
            {text}
        </Badge>
    );
};

const getIntegrationStatusProps = (status: TransactionIntegrationStatus) => {
    let color: BadgeColor;
    let icon: IconDefinition | undefined;
    let text = '';

    switch (status) {
        case 'failed':
            color = 'error';
            icon = faTriangleExclamation;
            text = 'Failed to sync';
            break;
        case 'pending':
            color = 'warning';
            text = 'Pending sync';
            break;
        case 'succeeded':
            color = 'success';
            text = 'Successful sync';
            break;
        default:
            color = 'neutral';
            break;
    }

    return {
        color,
        icon,
        text,
    };
};

export { TransactionIntegrationStatusBadge };
